import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import { useCustomSelector } from 'hooks';
import React, { useEffect, useState } from 'react';
import { useTableColumns } from './hooks/useTableColumns';
import ic_export from 'assets/images/ic_export.svg';

import "assets/scss/billingPortal/modules/reporting/posCount.scss";
import { convertArrayToDropdownArrayFormat, getTotalCountFromHeader, isArrayNotEmpty, isObjectEmpty } from 'functions';
import useReporting from 'dataflow/billingPortal/actions/useReporting.actions';
import { MultiFilters } from 'components/filters/MultiFilters';
import { Toaster } from "components/notification/Toaster";
import useAccountControlActions from 'dataflow/billingPortal/actions/useAccountControl.actions';
import { SubmenuTooltip } from 'components/informational/SubmenuTooltip';
import { MoreButton } from 'components/buttons/MoreButton';
import useExportData from './hooks/useExportData';
import moment from "moment";

export default function POSCount() {
    const [isExporting, setIsExporting] = useState();

    const {
        getAllComList_requesting, allComList
    } = useCustomSelector("accountControl");
    const {
        getPOSCountReport_requesting, posCountReport, posCountReportHeader,
        allPosCountReport, getAllPOSCountReport_requesting
    } = useCustomSelector("reporting");

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    const {
        getPOSCountReport, getAllPOSCountReport
    } = useReporting();

    const columns = useTableColumns();

    const { getAllComList } = useAccountControlActions();
    useEffect(() => {
        getAllComList();
    }, []);

    // handle export
    const exportData = useExportData();
    useEffect(() => {
        if (isExporting && !getAllPOSCountReport_requesting && isArrayNotEmpty(allPosCountReport)) 
            exportData();
    }, [getAllPOSCountReport_requesting]);

    console.log(moment().format());
    console.log(moment().endOf('month').format())

    return (
        <DashboardLayout
            headerTitle={"POS Count"}

            bodyClassName={"pos-count-report"}
            body={(
                <GeneralTable
                    className={"pos-count-report__table"}
                    columns={columns}
                    data={userPermissions?.Internal_PosCountReport_View? posCountReport: []}

                    getTableData={getPOSCountReport}

                    outerTableHeader={(outerTableHeader_props) => {
                        const { 
                            filterOptions, setFilterOptions
                        } = outerTableHeader_props;

                        return (
                            <div className={"table__headers"}>
                                {/* Top Section */}
                                <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                    {/* Title */}
                                    <div className={"headers__title tableHeaderTitle "}>
                                        List
                                    </div>

                                     {/* More Actions */}
                                     <SubmenuTooltip
                                        buttonClassName={"top-section__more-actions"}
                                        menuItems={[
                                            {
                                                icon: ic_export,
                                                label: "Export",
                                                onClick: () => {
                                                    setIsExporting(true);
                                                    getAllPOSCountReport(getTotalCountFromHeader(posCountReportHeader), filterOptions);
                                                },
                                            }
                                        ]}
                                    >
                                        <MoreButton
                                            className={"more-actions__icon-wrapper"}
                                            iconClassName={"icon-wrapper__icon"}
                                        />
                                    </SubmenuTooltip>
                                </div>

                                {/* Bottom Section */}
                                <div className={"headers__bottom-section d-flex"}>
                                    <MultiFilters
                                        defaultFilterOption={{
                                            label: "COM ID", 
                                            propertyName: "comId",
                                            placeholder: "COM ID",
                                            options: (isArrayNotEmpty(allComList))? allComList.map((obj) => {
                                                let comId = obj?.ComId? obj.ComId:"";
                                                let comName = obj?.ComName? obj?.ComName:"";

                                                return {
                                                    label: comId + " - " + comName,
                                                    value: comId
                                                };
                                            }):"",
                                            inputType: "dropdown",
                                        }}
                                        filterOptions={[
                                            {
                                                label: "COM ID", 
                                                propertyName: "comId",
                                                placeholder: "COM ID",
                                                options: (isArrayNotEmpty(allComList))? allComList.map((obj) => {
                                                    let comId = obj?.ComId? obj.ComId:"";
                                                    let comName = obj?.ComName? obj?.ComName:"";

                                                    return {
                                                        label: comId + " - " + comName,
                                                        value: comId
                                                    };
                                                }):"",
                                                inputType: "dropdown",
                                            },
                                            {
                                                label: "Date Range", 
                                                propertyName_start: "startDate",
                                                propertyName_end: "endDate",
                                                placeholder_start: "Start",
                                                placeholder_end: "End",
                                                inputType: "dateRange"
                                            },
                                            // {
                                            //     label: "Location", 
                                            //     propertyName: "locationName",
                                            //     placeholder: "Search Location",
                                            //     inputType: "search"
                                            // },
                                        ]}
                                        dropdownPlaceholder={"Select Filter"}
                                        onApplyFilter={(inputFilters) => {
                                            let newFilters = isObjectEmpty(inputFilters)? {}: { ...filterOptions, ...inputFilters};

                                            if ((newFilters?.comId && newFilters?.startDate && newFilters?.endDate) || isObjectEmpty(newFilters)) {
                                                setFilterOptions(newFilters);
                                            }
                                            else {
                                                let missingInputs = "";
                                                if (!(newFilters?.comId || newFilters?.startDate || newFilters?.endDate)) {
                                                    missingInputs = "Both COM ID & start/end dates";
                                                }
                                                else if (!newFilters?.comId) {
                                                    missingInputs = "COM ID";
                                                }
                                                else missingInputs = "Start & End dates";

                                                Toaster({
                                                    type: "info",
                                                    msg: missingInputs + " filter(s) required"
                                                })
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    }}
                    
                    isTableDataLoading={getPOSCountReport_requesting}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(posCountReportHeader)}

                    isColumnResizeable isAllColumnWidthEqual
                    isTableOddRowsDarken
                />
            )}
        />
    );
}